import { motion } from 'framer-motion';
import React from 'react';
import { ReactComponent as ClockIcon } from '../../Icons/clockIcon.svg';
import { ReactComponent as ReadIcon } from '../../Icons/readIcon.svg';
import '../../Styles/Blog/Blog.css';

const FacebookBlog = () => {
    return (
        <div className="blog-item-main-container flex-box">
            <motion.div className="blog-item-content-wrapper" initial={{ y: `-300%`, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.5, delay: 1 }}>
                <h4 className="blog-item-title">
                    <span onClick={() => window.open(`https://asguru.hashnode.dev/facebook-clone`)} className="pointer">Facebook clone</span>
                </h4>
                <p className="blog-item-brief-view flex-box">
                    <span className="flex-box pointer" onClick={() => window.open(`https://asguru.hashnode.dev/facebook-clone`)}>
                        <span className="flex-box blog-item-publish-date">Jun 22, 2021</span>
                        <span className="flex-box blog-item-minutes-of-read">
                            <ClockIcon />
                            6 min read
                        </span>
                        <span className="flex-box blog-item-number-of-views">
                            <ReadIcon />
                            12 views
                        </span>
                    </span>
                </p>
                <p onClick={() => window.open(`https://asguru.hashnode.dev/facebook-clone`)} className="pointer">
                    Here I have explained how me and my team built facebook, What tech stack we used with pictures to understand better.
                    All the fun and experience that we had during building this project, have a nice reading 😀.
                </p>
            </motion.div>
            <motion.div
                className="blog-item-image-wrapper flex-box pointer"
                onClick={() => window.open(`https://asguru.hashnode.dev/facebook-clone`)}
                initial={{ y: `-300%`, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 1 }}
            >
                <img className="blog-item-image-box" src={process.env.PUBLIC_URL + '/Images/facebookBlogCover.png'} alt="facebook blog" />
            </motion.div>
        </div>
    )
}

export default FacebookBlog
